import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { X, MapPin } from "lucide-react";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import SidebarRuteo from "../../../components/sidebar-ruteo";
import MapaRuteo from "../../../components/mapa-ruteo";
// import moment from "moment";
// import { obtenerPuntoActualVehiculo, obtenerTodasLasUnidades } from "../../../api/gestion-dts/gestion";
// import { obtenerEventoActualPorPlaca } from "../../../api/api-evento-actual";
import { obtenerPuntoActualVehiculo } from "../../../api/gestion-dts/gestion";

export default function RuteoPage
    () {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const [cargandoPage, setCargandoPage] = useState(true);
    // const [listaElementos, setListaElementos] = useState([]);
    // const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
    // const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
    // const [elementoSelected, setElementoSelected] = useState(null);
    // const [permisos, setPermisos] = useState(null);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);

    //   const [rowsData, setRowsData] = useState([]);
    const [itemsList, setItemsList] = useState([]);
    // const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));

    const [mapCenter, setMapCenter] = useState(null);
    const [mapZoom, setMapZoom] = useState(12);

    // const [listaVehiculos, setListaVehiculos] = useState([]);
    // const [vehiculoSelected, setVehiculoSelected] = useState(null);

    const [puntoActual, setPuntoActual] = useState(null);
    const idActivoRef = useRef(null);
    const [drawRoute, setDrawRoute] = useState(false);
    const [routeLegsInfo, setRouteLegsInfo] = useState([]);
    const [showRouteSummaryModal, setShowRouteSummaryModal] = useState(false);

    const [processingVisible, setProcessingVisible] = useState(false);
    const [toastVisible, setToastVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

    useEffect(() => {
        iniciar();
    }, []);

    // Poll puntoActual (vehicle position) every 15 seconds for tracking
    useEffect(() => {
        const interval = setInterval(async () => {
            if (idActivoRef.current == null) return;
            try {
                // const data = await obtenerEventoActualPorPlaca({ idActivo: idActivoRef.current });
                const data = await obtenerPuntoActualVehiculo(idActivoRef.current);
                // console.log('data=>', data);
                setPuntoActual(data);
            } catch (err) {
                console.warn("puntoActual poll err", err);
            }
        }, 15000);
        return () => clearInterval(interval);
    }, []);


    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);

            const listaItems = data.detailItems;
            const itemSelected = data.itemSelected;
            let itemsWithOrden = listaItems.map((item, index) => ({
                ...item,
                orden: index,
            }));
            setItemsList(itemsWithOrden);
            setMapCenter(null);
            setMapZoom(15);
            setCargandoPage(false);

            // Fetch puntoActual in background so the map shows immediately with items; when it arrives we fitBounds again
            idActivoRef.current = itemSelected.valuePlaca;
            obtenerPuntoActualVehiculo(itemSelected.valuePlaca)
                .then(setPuntoActual)
                .catch((err) => {
                    console.warn("puntoActual initial fetch err", err);
                });
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const showToast = (message, type = "warning", durationMs = 3000) => {
        setToastMessage(message);
        setToastType(type);
        setToastVisible(true);
        // Auto-hide
        window.clearTimeout(showToast._timer);
        showToast._timer = window.setTimeout(() => {
            setToastVisible(false);
        }, durationMs);
    };

    const handleItemsChange = (updatedItems) => {
        setItemsList(updatedItems);
        setDrawRoute(false); // Clear route when user reorders so they can draw it again manually
    };

    const handleViewRoute = () => {
        setMapCenter(null); // so map fits to route instead of staying on a previously clicked item
        setDrawRoute(true);
    };

    const handleClearRoute = () => {
        setDrawRoute(false);
    };

    const handleItemClick = (item) => {
        // Handle item click - center map on item's location
        // console.log('Item clicked:', item);

        if (item.latitud && item.longitud) {
            const lat = parseFloat(item.latitud);
            const lng = parseFloat(item.longitud);

            // Check if coordinates are valid
            if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
                setMapCenter({
                    lat: lat,
                    lng: lng
                });
                setMapZoom(20); // Zoom in closer when focusing on an item
            }
        }
    };

    const render = () => {
        try {
            // console.log('listar correo render');
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (tieneAccesoAlModulo === false) {
                return sinAccesoCard();
            }
            return (
                <div className="h-screen flex flex-col overflow-hidden">
                    <div className="flex-1 flex overflow-hidden relative">
                        <SidebarRuteo
                            items={itemsList}
                            onItemsChange={handleItemsChange}
                            onItemClick={handleItemClick}
                            onViewRoute={handleViewRoute}
                            onClearRoute={handleClearRoute}
                            setProcessingVisible={setProcessingVisible}
                            showToast={showToast}
                            toastMessage={toastMessage}
                            vehiculoSelected={puntoActual}
                            showRouteSummaryButton={routeLegsInfo.length > 0}
                            onShowRouteSummary={() => setShowRouteSummaryModal(true)}
                        />

                        {/* Map - Adjusts based on visible panels */}
                        <div className={`flex-1 min-w-0 relative`} style={{ zIndex: 1 }}>
                            <MapaRuteo
                                items={itemsList}
                                puntoActual={puntoActual}
                                drawRoute={drawRoute}
                                center={mapCenter}
                                zoom={mapZoom}
                                onMarkerClick={(marker) => {
                                    console.log("Marker clicked:", marker);
                                }}
                                onMapClick={(lat, lng) => { }}
                                onRouteLegsChange={setRouteLegsInfo}
                            />
                        </div>

                    </div>

                    {/* Route summary / timeline modal */}
                    {showRouteSummaryModal && routeLegsInfo.length > 0 && (() => {
                        const totalSeconds = routeLegsInfo.reduce((acc, leg) => acc + (leg.duration?.value || 0), 0);
                        const totalMeters = routeLegsInfo.reduce((acc, leg) => acc + (leg.distance?.value || 0), 0);
                        const totalMinutes = Math.round(totalSeconds / 60);
                        const totalKm = (totalMeters / 1000).toFixed(1);
                        return (
                            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4">
                                <div className="bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-md max-h-[85vh] flex flex-col">
                                    <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
                                        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                                            <MapPin className="h-5 w-5 text-blue-600" />
                                            {t("label_resumen_recorrido")}
                                        </h3>
                                        <button
                                            type="button"
                                            onClick={() => setShowRouteSummaryModal(false)}
                                            className="p-1 hover:bg-gray-100 rounded-lg"
                                            aria-label={t("label_cerrar") || "Cerrar"}
                                        >
                                            <X className="h-5 w-5 text-gray-600" />
                                        </button>
                                    </div>
                                    <div className="p-4 border-b border-gray-100 bg-gray-50 flex gap-4">
                                        <div className="flex-1 text-center">
                                            <div className="text-2xl font-bold text-gray-900">{totalMinutes} min</div>
                                            <div className="text-xs text-gray-500">{t("label_tiempo_total") || "Tiempo total"}</div>
                                        </div>
                                        <div className="flex-1 text-center">
                                            <div className="text-2xl font-bold text-gray-900">{totalKm} km</div>
                                            <div className="text-xs text-gray-500">{t("label_distancia_total") || "Distancia total"}</div>
                                        </div>
                                    </div>
                                    <div className="p-4 overflow-y-auto flex-1">
                                        <ul className="space-y-0">
                                            {routeLegsInfo.map((leg, idx) => (
                                                <li key={idx} className="flex gap-3 py-3 border-b border-gray-100 last:border-0">
                                                    <div className="flex flex-col items-center flex-shrink-0">
                                                        <div className="w-3 h-3 rounded-full bg-blue-500" />
                                                        {idx < routeLegsInfo.length - 1 && (
                                                            <div className="w-0.5 flex-1 min-h-[24px] bg-gray-200 my-0.5" />
                                                        )}
                                                    </div>
                                                    <div className="flex-1 min-w-0">
                                                        <div className="font-medium text-gray-900 truncate">{leg.fromLabel}</div>
                                                        <div className="text-xs text-gray-500 mt-0.5">
                                                            {leg.duration?.text || "—"} · {leg.distance?.text || "—"}
                                                        </div>
                                                        <div className="font-medium text-gray-700 truncate mt-1">{leg.toLabel}</div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="px-4 py-3 border-t border-gray-200">
                                        <button
                                            type="button"
                                            onClick={() => setShowRouteSummaryModal(false)}
                                            className="w-full px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-sm font-medium"
                                        >
                                            {t("label_cerrar") || "Cerrar"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })()}

                    <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
                    <ToastComponent
                        visible={toastVisible}
                        message={toastMessage}
                        type={toastType}
                        onClose={() => setToastVisible(false)}
                    />
                </div>
            );
        } catch (err) {
            console.log('MapaSeguimientoPage render err');
            console.log(err);
            return (
                <div><label>{JSON.stringify(err)}</label></div>
            );
        }
    }

    return render();
}
